import React, { useState } from 'react'
import Button from 'components/button'
import Input from 'components/input'

export interface IFormValues {
  email?: string
  password?: string
}

interface Props {
  onSubmit: (values: IFormValues) => void
  initialEmail: string
}

const LoginForm: React.FC<Props> = ({ onSubmit, initialEmail }) => {
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [password, setPassword] = useState<string | undefined>(undefined)

  const handleSubmit = async () => {
    if (initialEmail && password) {
      setSubmitting(true)
      await onSubmit({
        email: initialEmail,
        password
      })
      setSubmitting(false)
    }
  }

  return (
    <div className="w-full">
      <Input
        name="email"
        type="text"
        placeholder="Your email address"
        data-cy="email-input"
        value={initialEmail}
        autoComplete="email"
        disabled
        className="cursor-not-allowed opacity-60"
      />

      <Input
        className="mt-5"
        name="password"
        type="password"
        placeholder="Your password"
        data-cy="password-input"
        onChange={(event) => setPassword(event.target.value)}
        autoComplete="current-password"
      />
      <Button
        className="mt-5 w-full text-[1rem]"
        onClick={() => handleSubmit()}
        isLoading={submitting}
        data-cy="signin-button"
      >
        Sign In
      </Button>
    </div>
  )
}

export default LoginForm
